import { LogsActionsServiceName } from '@/common/constants';
import { useLogsActionsDrawer } from './useLogsActionsDrawer';
import type { LogsActionsDrawerContext } from '../stores/logsActionsDrawerStore';

export interface DebugLogsUserIdentity {
  username?: string;
  fullname?: string;
  firstName?: string;
  lastName?: string;
}

export interface OpenDebugLogsOptions {
  serviceName: LogsActionsServiceName;
  user?: DebugLogsUserIdentity;
  initialFrom?: string;
  initialTo?: string;
  initialMinStatusCode?: number | null;
  initialMaxStatusCode?: number | null;
  initialTop?: number;
}

const resolveFullname = (user?: DebugLogsUserIdentity): string => {
  if (!user) {
    return '';
  }

  if (user.fullname?.trim()) {
    return user.fullname.trim();
  }

  return `${user.lastName ?? ''} ${user.firstName ?? ''}`.trim();
};

const toDrawerContext = (options: OpenDebugLogsOptions): LogsActionsDrawerContext => ({
  serviceName: options.serviceName,
  initialUsername: options.user?.username?.trim() || '',
  initialFullname: resolveFullname(options.user),
  initialFrom: options.initialFrom ?? '',
  initialTo: options.initialTo ?? '',
  initialMinStatusCode: options.initialMinStatusCode ?? null,
  initialMaxStatusCode: options.initialMaxStatusCode ?? null,
  initialTop: options.initialTop,
});

export const useDebugLogsLauncher = () => {
  const { openLogsActionsDrawer } = useLogsActionsDrawer();

  const openDebugLogs = (options: OpenDebugLogsOptions) => {
    openLogsActionsDrawer(toDrawerContext(options));
  };

  return {
    openDebugLogs,
  };
};
